import { gql } from '@apollo/client';

export const GQL_GET_GENRES = gql`
  query getGenreFilteredList($search: GenreSearchInput) {
    getGenreFilteredList(search: $search) {
      id
      name
    }
  }
`;
